import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { TimelineMax, TweenMax, Elastic } from 'gsap/TweenMax';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';

const ChooseHosts = ({ play, ...rest }) => {
  const svgRef = useRef();
  const backgroundRimRef = useRef();
  const numberHostsRef = useRef();
  const numberHostsSubRef = useRef();
  const innerRimRef = useRef([]);
  const outerRimRef = useRef([]);
  const bottomLabelLeftRef = useRef();
  const bottomLabelRightRef = useRef();

  const timeline = useRef();

  useEffect(() => {
    TweenMax.set(svgRef.current, {
      visibility: 'visible',
    });

    timeline.current = new TimelineMax({
      paused: !play,
    });

    const ease = Elastic.easeOut.config(1, 1);

    timeline.current
      .from(
        numberHostsRef.current,
        1,
        {
          alpha: 0,
          y: -10,
          transformOrigin: 'center center',
          ease,
        },
        'labels'
      )
      .from(
        numberHostsSubRef.current,
        1,
        {
          alpha: 0,
          y: 10,
          transformOrigin: 'center center',
          ease,
        },
        'labels'
      )
      .from(backgroundRimRef.current, 1, {
        scale: 0,
        transformOrigin: 'center center',
        rotation: 360,
        ease,
      })
      .from(bottomLabelLeftRef.current, 0.5, {
        alpha: 0,
        x: -5,
        ease,
      })
      .from(bottomLabelRightRef.current, 0.5, {
        alpha: 0,
        x: -5,
        ease,
      })
      .from(
        [
          outerRimRef.current[6],
          outerRimRef.current[7],
          innerRimRef.current[2],
        ],
        0.75,
        {
          alpha: 0,
          scale: 0.75,
          transformOrigin: 'center center',
          ease,
        },
        'fills'
      )
      .from(
        [
          outerRimRef.current[0],
          outerRimRef.current[1],
          outerRimRef.current[2],
          outerRimRef.current[3],
          innerRimRef.current[0],
        ],
        0.75,
        {
          delay: 0.5,
          alpha: 0,
          scale: 0.75,
          transformOrigin: 'center center',
          ease,
        },
        'fills'
      )
      .from(
        [
          outerRimRef.current[4],
          outerRimRef.current[5],
          innerRimRef.current[1],
        ],
        0.75,
        {
          delay: 1,
          alpha: 0,
          scale: 0.75,
          transformOrigin: 'center center',
          ease,
        },
        'fills'
      );

    return () => {
      if (timeline.current) timeline.current.kill();
    };
  }, []);

  useUpdateEffect(() => {
    if (play) {
      timeline.current.play();
    }
  });

  const handleClick = () => {
    if (timeline.current) timeline.current.restart();
  };

  return (
    <svg
      className="product__scenarios-scaleSvg"
      ref={svgRef}
      viewBox="0 0 403 597"
      onClick={handleClick}
      {...rest}
    >
      <defs>
        <path
          id="ChooseHosts__prefix__d"
          d="M20 25.333l10.903-7.64L33.333 16 20 6.667 6.667 16l2.415 1.693L20 25.333zm0 3.387L9.067 21.08l-2.4 1.68L20 32.093l13.333-9.333-2.415-1.693L20 28.72z"
        />
        <path id="ChooseHosts__prefix__g" d="M0 0h345v464a5 5 0 01-5 5H0V0z" />
        <path id="ChooseHosts__prefix__i" d="M0 0h345v45H0z" />
        <path
          id="ChooseHosts__prefix__j"
          d="M4 0h36v24H4a4 4 0 01-4-4V4a4 4 0 014-4zm36 0l5.5 11L40 24a.013.013 0 00.013-.013V.013A.013.013 0 0040 0z"
        />
        <path
          id="ChooseHosts__prefix__k"
          d="M0 0h67a4 4 0 014 4v16a4 4 0 01-4 4H0V0zm0 0c.01 0 .02.009.02.02v23.96A.02.02 0 010 24l5.5-13L0 0z"
        />
        <filter
          id="ChooseHosts__prefix__a"
          width="115.6%"
          height="110.2%"
          x="-7.8%"
          y="-5.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="ChooseHosts__shadowOffsetOuter1" />
          <feGaussianBlur
            in="ChooseHosts__shadowOffsetOuter1"
            result="ChooseHosts__shadowBlurOuter1"
            stdDeviation={9.5}
          />
          <feColorMatrix
            in="ChooseHosts__shadowBlurOuter1"
            values="0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.504725743 0"
          />
        </filter>
        <filter
          id="ChooseHosts__prefix__f"
          width="100.6%"
          height="100.2%"
          x="-.4%"
          y="-.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dx={-1}
            in="SourceAlpha"
            result="ChooseHosts__shadowOffsetOuter1"
          />
          <feColorMatrix
            in="ChooseHosts__shadowOffsetOuter1"
            values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"
          />
        </filter>
        <filter
          id="ChooseHosts__prefix__h"
          width="100.3%"
          height="104.4%"
          x="-.1%"
          y="-1.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dy={1}
            in="SourceAlpha"
            result="ChooseHosts__shadowOffsetOuter1"
          />
          <feColorMatrix
            in="ChooseHosts__shadowOffsetOuter1"
            values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"
          />
        </filter>
        <linearGradient
          id="ChooseHosts__prefix__c"
          x1="41.228%"
          x2="41.452%"
          y1="-99.743%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#FFF" />
          <stop offset="100%" stopColor="#E4E8F2" />
        </linearGradient>
        <rect id="ChooseHosts__prefix__b" width={365} height={559} rx={5} />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(19 19)">
        <use
          fill="#000"
          filter="url(#ChooseHosts__prefix__a)"
          xlinkHref="#ChooseHosts__prefix__b"
        />
        <use
          fill="url(#ChooseHosts__prefix__c)"
          xlinkHref="#ChooseHosts__prefix__b"
        />
        <path
          fill="#F8F8F8"
          stroke="#E6E6E6"
          d="M20.5 89.5h345V4A3.5 3.5 0 00362 .5H24A3.5 3.5 0 0020.5 4v85.5z"
        />
        <path
          fill="#3A3F4C"
          fillRule="nonzero"
          d="M102.432 43.24c-3.168 0-5.808-2.288-5.808-5.904s2.736-5.92 5.776-5.92c3.136 0 4.752 1.92 5.2 3.76l-2.08.656c-.272-1.088-1.152-2.288-3.12-2.288-1.696 0-3.488 1.216-3.488 3.792 0 2.416 1.696 3.744 3.52 3.744 1.936 0 2.88-1.264 3.184-2.32l2.064.624c-.432 1.744-2.064 3.856-5.248 3.856zm9.056-4.864V43h-2.128V31.416h2.128v4.368c.512-.608 1.376-.864 2.128-.864 2 0 2.928 1.392 2.928 3.12V43h-2.128v-4.592c0-.88-.432-1.568-1.456-1.568-.896 0-1.424.672-1.472 1.536zm10.752 2.928c1.04 0 2-.752 2-2.24 0-1.488-.96-2.24-2-2.24s-2 .752-2 2.24c0 1.472.96 2.24 2 2.24zm0-6.416c2.352 0 4.128 1.744 4.128 4.176 0 2.416-1.776 4.176-4.128 4.176-2.352 0-4.128-1.76-4.128-4.176 0-2.432 1.776-4.176 4.128-4.176zm9.344 6.416c1.04 0 2-.752 2-2.24 0-1.488-.96-2.24-2-2.24s-2 .752-2 2.24c0 1.472.96 2.24 2 2.24zm0-6.416c2.352 0 4.128 1.744 4.128 4.176 0 2.416-1.776 4.176-4.128 4.176-2.352 0-4.128-1.76-4.128-4.176 0-2.432 1.776-4.176 4.128-4.176zm5.136 5.92l1.824-.4c.048.624.512 1.2 1.44 1.2.704 0 1.04-.368 1.04-.784 0-.352-.24-.64-.848-.768l-1.04-.24c-1.52-.336-2.208-1.248-2.208-2.352 0-1.408 1.248-2.576 2.944-2.576 2.24 0 2.992 1.424 3.088 2.272l-1.776.4c-.064-.464-.4-1.056-1.296-1.056-.56 0-1.008.336-1.008.784 0 .384.288.624.72.704l1.12.24c1.552.32 2.336 1.264 2.336 2.416 0 1.28-.992 2.592-3.056 2.592-2.368 0-3.184-1.536-3.28-2.432zm9.6-2.64h3.52c-.032-.784-.544-1.552-1.76-1.552-1.104 0-1.712.832-1.76 1.552zm3.728 2.048l1.776.528c-.4 1.36-1.648 2.496-3.584 2.496-2.16 0-4.064-1.552-4.064-4.208 0-2.512 1.856-4.144 3.872-4.144 2.432 0 3.888 1.552 3.888 4.08 0 .304-.032.624-.032.656h-5.632c.048 1.04.928 1.792 1.984 1.792.992 0 1.536-.496 1.792-1.2zm9.648-1.84V43h-2.128V31.416h2.128v4.368c.512-.608 1.376-.864 2.128-.864 2 0 2.928 1.392 2.928 3.12V43h-2.128v-4.592c0-.88-.432-1.568-1.456-1.568-.896 0-1.424.672-1.472 1.536zm10.752 2.928c1.04 0 2-.752 2-2.24 0-1.488-.96-2.24-2-2.24s-2 .752-2 2.24c0 1.472.96 2.24 2 2.24zm0-6.416c2.352 0 4.128 1.744 4.128 4.176 0 2.416-1.776 4.176-4.128 4.176-2.352 0-4.128-1.76-4.128-4.176 0-2.432 1.776-4.176 4.128-4.176zm5.136 5.92l1.824-.4c.048.624.512 1.2 1.44 1.2.704 0 1.04-.368 1.04-.784 0-.352-.24-.64-.848-.768l-1.04-.24c-1.52-.336-2.208-1.248-2.208-2.352 0-1.408 1.248-2.576 2.944-2.576 2.24 0 2.992 1.424 3.088 2.272l-1.776.4c-.064-.464-.4-1.056-1.296-1.056-.56 0-1.008.336-1.008.784 0 .384.288.624.72.704l1.12.24c1.552.32 2.336 1.264 2.336 2.416 0 1.28-.992 2.592-3.056 2.592-2.368 0-3.184-1.536-3.28-2.432zm10.672-8.032v2.352h1.584v1.888h-1.584v3.296c0 .688.32.912.928.912.256 0 .544-.032.656-.064v1.76c-.192.08-.576.192-1.2.192-1.536 0-2.496-.912-2.496-2.432v-3.664h-1.424v-1.888h.4c.832 0 1.216-.544 1.216-1.248v-1.104h1.92zm2.672 8.032l1.824-.4c.048.624.512 1.2 1.44 1.2.704 0 1.04-.368 1.04-.784 0-.352-.24-.64-.848-.768l-1.04-.24c-1.52-.336-2.208-1.248-2.208-2.352 0-1.408 1.248-2.576 2.944-2.576 2.24 0 2.992 1.424 3.088 2.272l-1.776.4c-.064-.464-.4-1.056-1.296-1.056-.56 0-1.008.336-1.008.784 0 .384.288.624.72.704l1.12.24c1.552.32 2.336 1.264 2.336 2.416 0 1.28-.992 2.592-3.056 2.592-2.368 0-3.184-1.536-3.28-2.432z"
        />
        <g transform="translate(44 25)">
          <mask id="ChooseHosts__prefix__e" fill="#fff">
            <use xlinkHref="#ChooseHosts__prefix__d" />
          </mask>
          <use
            fill="#000"
            fillRule="nonzero"
            xlinkHref="#ChooseHosts__prefix__d"
          />
          <g fill="#23C386" mask="url(#ChooseHosts__prefix__e)">
            <path d="M0 0h40v40H0z" />
          </g>
        </g>
        <g transform="translate(20 90)">
          <g transform="matrix(-1 0 0 1 345 0)">
            <use
              fill="#000"
              filter="url(#ChooseHosts__prefix__f)"
              xlinkHref="#ChooseHosts__prefix__g"
            />
            <use fill="#FFF" xlinkHref="#ChooseHosts__prefix__g" />
          </g>
          <use
            fill="#000"
            filter="url(#ChooseHosts__prefix__h)"
            xlinkHref="#ChooseHosts__prefix__i"
          />
          <use fill="#FFF" xlinkHref="#ChooseHosts__prefix__i" />
          {/*
          <path
            ref={numberHostsRef}
            fill="#3A3F4C"
            fillRule="nonzero"
            d="M154.864 74.816c0 1.088.16 2.016.56 2.64.32.512.816.848 1.568.848.768 0 1.232-.336 1.552-.848.416-.624.576-1.552.576-2.64s-.16-2.016-.576-2.64c-.32-.512-.784-.848-1.552-.848-.752 0-1.248.336-1.568.848-.4.624-.56 1.552-.56 2.64zm-2.208 0c0-1.328.208-2.624.912-3.696.688-1.024 1.808-1.744 3.424-1.744 1.616 0 2.736.72 3.408 1.744.704 1.072.928 2.368.928 3.696 0 1.328-.224 2.624-.928 3.696-.672 1.024-1.792 1.744-3.408 1.744-1.616 0-2.736-.72-3.424-1.744-.704-1.072-.912-2.368-.912-3.696zm17.952 3.488c1.04 0 2-.752 2-2.24 0-1.488-.96-2.24-2-2.24s-2 .752-2 2.24c0 1.472.96 2.24 2 2.24zm0-6.416c2.352 0 4.128 1.744 4.128 4.176 0 2.416-1.776 4.176-4.128 4.176-2.352 0-4.128-1.76-4.128-4.176 0-2.432 1.776-4.176 4.128-4.176zm9.456-1.712c-.48 0-1.104.208-1.104 1.088v.864h1.776v1.824h-1.776V80h-2.144v-6.048h-1.312v-1.824h1.312v-.896c0-1.776 1.12-2.928 2.864-2.928.448 0 .88.08 1.056.16v1.792a2.38 2.38 0 00-.672-.08zm7.728 4.64c0 1.088.16 2.016.56 2.64.32.512.816.848 1.568.848.768 0 1.232-.336 1.552-.848.416-.624.576-1.552.576-2.64s-.16-2.016-.576-2.64c-.32-.512-.784-.848-1.552-.848-.752 0-1.248.336-1.568.848-.4.624-.56 1.552-.56 2.64zm-2.208 0c0-1.328.208-2.624.912-3.696.688-1.024 1.808-1.744 3.424-1.744 1.616 0 2.736.72 3.408 1.744.704 1.072.928 2.368.928 3.696 0 1.328-.224 2.624-.928 3.696-.672 1.024-1.792 1.744-3.408 1.744-1.616 0-2.736-.72-3.424-1.744-.704-1.072-.912-2.368-.912-3.696z"
          /> */}
          <text
            className="product__svgText"
            ref={numberHostsRef}
            fill="#3A3F4C"
            x="151"
            y="80"
          >
            <tspan>3</tspan> of 3
          </text>
          <path
            ref={numberHostsSubRef}
            fill="#768599"
            fillRule="nonzero"
            d="M131.065 95h-1.39v-2.94h-3.09V95h-1.38v-7.09h1.38v2.85h3.09v-2.85h1.39V95zm3.13-3.55c0 1.6 1.12 2.36 2.21 2.36 1.1 0 2.22-.76 2.22-2.36 0-1.6-1.12-2.36-2.22-2.36-1.09 0-2.21.76-2.21 2.36zm-1.43.01c0-2.29 1.72-3.7 3.64-3.7 1.93 0 3.65 1.41 3.65 3.7 0 2.28-1.72 3.69-3.65 3.69-1.92 0-3.64-1.41-3.64-3.69zm13.74-1.86l-1.24.38c-.07-.39-.39-1-1.29-1-.67 0-1.11.43-1.11.9 0 .39.25.7.77.8l.99.19c1.29.25 1.98 1.09 1.98 2.09 0 1.09-.91 2.19-2.56 2.19-1.88 0-2.71-1.21-2.82-2.22l1.28-.34c.06.7.55 1.33 1.55 1.33.74 0 1.15-.37 1.15-.87 0-.41-.31-.73-.86-.84l-.99-.2c-1.13-.23-1.86-.96-1.86-2.03 0-1.26 1.13-2.22 2.47-2.22 1.72 0 2.38 1.04 2.54 1.84zm6.97-.38h-2.24V95h-1.39v-5.78h-2.24v-1.31h5.87v1.31zm6.24.38l-1.24.38c-.07-.39-.39-1-1.29-1-.67 0-1.11.43-1.11.9 0 .39.25.7.77.8l.99.19c1.29.25 1.98 1.09 1.98 2.09 0 1.09-.91 2.19-2.56 2.19-1.88 0-2.71-1.21-2.82-2.22l1.28-.34c.06.7.55 1.33 1.55 1.33.74 0 1.15-.37 1.15-.87 0-.41-.31-.73-.86-.84l-.99-.2c-1.13-.23-1.86-.96-1.86-2.03 0-1.26 1.13-2.22 2.47-2.22 1.72 0 2.38 1.04 2.54 1.84zm9.96-.38h-2.24V95h-1.39v-5.78h-2.24v-1.31h5.87v1.31zm5.63 5.78l-.59-1.62h-2.88l-.59 1.62h-1.46l2.72-7.09h1.6l2.7 7.09h-1.5zm-2.03-5.56l-.98 2.68h1.96l-.98-2.68zm8.44 5.56l-1.39-2.73h-.72V95h-1.39v-7.09h2.77c1.38 0 2.26.95 2.26 2.18 0 .99-.58 1.74-1.51 2.01l1.52 2.9h-1.54zm-2.11-3.92h1.12c.7 0 1.11-.4 1.11-.98 0-.6-.41-.99-1.11-.99h-1.12v1.97zm11.73 3.92h-1.12l-.09-.81c-.32.48-1.02.96-2.09.96-1.91 0-3.54-1.4-3.54-3.69s1.71-3.7 3.63-3.7c1.86 0 2.89 1.09 3.24 2.18l-1.32.47c-.18-.63-.77-1.36-1.92-1.36-1.07 0-2.23.73-2.23 2.41 0 1.6 1.05 2.43 2.24 2.43 1.31 0 1.82-.88 1.9-1.38h-2.24v-1.2h3.54V95zm6.33 0h-4.44v-7.09h4.44v1.3h-3.06v1.62h2.77v1.23h-2.77v1.64h3.06V95zm7.22-5.78h-2.24V95h-1.39v-5.78h-2.24v-1.31h5.87v1.31zm5.91 5.78h-4.44v-7.09h4.44v1.3h-3.06v1.62h2.77v1.23h-2.77v1.64h3.06V95zm3.26-1.28h1.1c1.16 0 2.13-.72 2.13-2.26 0-1.54-.96-2.27-2.12-2.27h-1.11v4.53zm1.15 1.28h-2.53v-7.09h2.54c2.02 0 3.5 1.31 3.5 3.55 0 2.24-1.49 3.54-3.51 3.54z"
          />
          <g transform="translate(117 413)">
            <g ref={bottomLabelLeftRef}>
              <use fill="#1D6854" xlinkHref="#ChooseHosts__prefix__j" />
              <rect width={30} height={5} x={6} y={9} fill="#FFF" rx={2.5} />
            </g>

            <g ref={bottomLabelRightRef}>
              <use
                fill="#47C085"
                transform="translate(42)"
                xlinkHref="#ChooseHosts__prefix__k"
              />
              <rect width={52} height={5} x={52} y={9} fill="#FFF" rx={2.5} />
            </g>
          </g>
          <g ref={backgroundRimRef} transform="translate(39 119)">
            <rect width={268} height={268} fill="#FFF" rx={134} />
            <path
              fill="#F2F2F2"
              fillRule="nonzero"
              d="M132.5 47h3c47.22 0 85.5 38.28 85.5 85.5v3c0 47.22-38.28 85.5-85.5 85.5h-3C85.28 221 47 182.72 47 135.5v-3C47 85.28 85.28 47 132.5 47zm0 43C109.028 90 90 109.028 90 132.5v3c0 23.472 19.028 42.5 42.5 42.5h3c23.472 0 42.5-19.028 42.5-42.5v-3c0-23.472-19.028-42.5-42.5-42.5h-3z"
            />
            <path
              fill="#F2F2F2"
              fillRule="nonzero"
              d="M134 2c72.902 0 132 59.098 132 132s-59.098 132-132 132S2 206.902 2 134 61.098 2 134 2zm0 43c-49.153 0-89 39.847-89 89s39.847 89 89 89 89-39.847 89-89-39.847-89-89-89z"
            />
            <path fill="#FFF" d="M47 135h43v1H47zm87-88h-1v175h1z" />
          </g>
          <path
            fill="#3A3F4C"
            fillRule="nonzero"
            d="M109.296 18.656h4.08c2.208 0 3.456 1.296 3.456 3.056 0 1.168-.704 2.112-1.648 2.432 1.104.272 2 1.28 2 2.688 0 1.84-1.376 3.168-3.504 3.168h-4.384V18.656zm2.176 4.688h1.568c1.008 0 1.616-.56 1.616-1.424 0-.864-.56-1.408-1.632-1.408h-1.552v2.832zm0 4.816h1.792c1.072 0 1.712-.56 1.712-1.472 0-.896-.576-1.52-1.68-1.52h-1.824v2.992zM127.653 30h-7.264V18.656h2.208v9.232h5.056V30zm10.854 0l-.944-2.592h-4.608L132.01 30h-2.336l4.352-11.344h2.56L140.907 30h-2.4zm-3.248-8.896l-1.568 4.288h3.136l-1.568-4.288zm16.005.256l-1.984.608c-.112-.624-.624-1.6-2.064-1.6-1.072 0-1.776.688-1.776 1.44 0 .624.4 1.12 1.232 1.28l1.584.304c2.064.4 3.168 1.744 3.168 3.344 0 1.744-1.456 3.504-4.096 3.504-3.008 0-4.336-1.936-4.512-3.552l2.048-.544c.096 1.12.88 2.128 2.48 2.128 1.184 0 1.84-.592 1.84-1.392 0-.656-.496-1.168-1.376-1.344l-1.584-.32c-1.808-.368-2.976-1.536-2.976-3.248 0-2.016 1.808-3.552 3.952-3.552 2.752 0 3.808 1.664 4.064 2.944zm11.685-.608h-3.584V30h-2.224v-9.248h-3.584v-2.096h9.392v2.096zM176.72 30l-2.224-4.368h-1.152V30h-2.224V18.656h4.432c2.208 0 3.616 1.52 3.616 3.488 0 1.584-.928 2.784-2.416 3.216l2.432 4.64h-2.464zm-3.376-6.272h1.792c1.12 0 1.776-.64 1.776-1.568 0-.96-.656-1.584-1.776-1.584h-1.792v3.152zM190.117 30l-.944-2.592h-4.608L183.621 30h-2.336l4.352-11.344h2.56L192.517 30h-2.4zm-3.248-8.896l-1.568 4.288h3.136l-1.568-4.288zm10.646 6.848h1.76c1.856 0 3.408-1.152 3.408-3.616 0-2.464-1.536-3.632-3.392-3.632h-1.776v7.248zm1.84 2.048h-4.048V18.656h4.064c3.232 0 5.6 2.096 5.6 5.68 0 3.584-2.384 5.664-5.616 5.664zm11.109 0h-2.24V18.656h2.24V30zm8.165.256c-2.416 0-4.352-1.488-4.352-4.272v-7.328h2.208v7.168c0 1.488.832 2.272 2.144 2.272 1.344 0 2.16-.784 2.16-2.272v-7.168h2.208v7.328c0 2.784-1.936 4.272-4.368 4.272zm15.814-8.896l-1.984.608c-.112-.624-.624-1.6-2.064-1.6-1.072 0-1.776.688-1.776 1.44 0 .624.4 1.12 1.232 1.28l1.584.304c2.064.4 3.168 1.744 3.168 3.344 0 1.744-1.456 3.504-4.096 3.504-3.008 0-4.336-1.936-4.512-3.552l2.048-.544c.096 1.12.88 2.128 2.48 2.128 1.184 0 1.84-.592 1.84-1.392 0-.656-.496-1.168-1.376-1.344l-1.584-.32c-1.808-.368-2.976-1.536-2.976-3.248 0-2.016 1.808-3.552 3.952-3.552 2.752 0 3.808 1.664 4.064 2.944z"
          />
        </g>
        <rect
          width={140}
          height={8}
          x={96}
          y={52}
          fill="#8899AE"
          opacity={0.401}
          rx={4}
        />
        <g
          id="ChooseHosts__Blast_Animation"
          transform="translate(61.000000, 211.000000)"
        >
          <g>
            <path
              d="M218.9905,130.49 L218.9905,133.49 C218.9905,180.711 180.7105,218.99 133.4905,218.99 L132.7405,218.99 L132.7405,175.99 L133.4905,175.99 C156.9605,175.99 175.9905,156.961 175.9905,133.49 L175.9905,130.49 C175.9905,107.011 156.9605,87.99 133.4905,87.99 L132.7405,87.99 L132.7405,44.99 L133.4905,44.99 C180.7105,44.99 218.9905,83.27 218.9905,130.49"
              fill="#1D6854"
              ref={element => {
                innerRimRef.current[0] = element;
              }}
            />

            <path
              d="M131.2405,175.99 L131.2405,218.99 L130.4905,218.99 C83.2705,218.99 44.9905,180.711 44.9905,133.49 L44.9905,132.74 L87.9905,132.74 L87.9905,133.49 C87.9905,156.961 107.0205,175.99 130.4905,175.99 L131.2405,175.99 Z"
              fill="#1D6854"
              ref={element => {
                innerRimRef.current[1] = element;
              }}
            />
            <path
              d="M131.2405,44.99 L131.2405,87.99 L130.4905,87.99 C107.0205,87.99 87.9905,107.011 87.9905,130.49 L87.9905,131.24 L44.9905,131.24 L44.9905,130.49 C44.9905,83.27 83.2705,44.99 130.4905,44.99 L131.2405,44.99 Z"
              fill="#1D6854"
              ref={element => {
                innerRimRef.current[2] = element;
              }}
            />
          </g>
          <g>
            <path
              d="M132.7405,-0.0002 L132.7405,42.9998 C156.7495,43.1988 178.4905,52.9008 194.3865,68.5328 L224.7935,38.1268 C201.1135,14.7148 168.6235,0.1998 132.7405,-0.0002"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[0] = element;
              }}
            />
            <path
              d="M195.4476,69.5935 C211.0796,85.4895 220.7826,107.2285 220.9806,131.2395 L263.9806,131.2395 C263.7816,95.3545 249.2656,62.8645 225.8536,39.1875 L195.4476,69.5935 Z"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[1] = element;
              }}
            />
            <path
              d="M220.9808,132.74 C220.7828,156.748 211.0788,178.488 195.4458,194.385 L225.8518,224.792 C249.2648,201.112 263.7808,168.623 263.9808,132.74 L220.9808,132.74 Z"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[2] = element;
              }}
            />
            <path
              d="M194.3851,195.4461 C178.4891,211.0781 156.7481,220.7831 132.7401,220.9811 L132.7401,263.9811 C168.6231,263.7811 201.1131,249.2651 224.7911,225.8521 L194.3851,195.4461 Z"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[3] = element;
              }}
            />
            <path
              d="M131.2405,220.9812 C107.2285,220.7832 85.4895,211.0792 69.5945,195.4472 L39.1875,225.8532 C62.8655,249.2652 95.3535,263.7812 131.2405,263.9812 L131.2405,220.9812 Z"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[4] = element;
              }}
            />
            <path
              d="M68.5335,194.3865 C52.9005,178.4905 43.1985,156.7485 42.9995,132.7405 L-0.000499999998,132.7405 C0.2005,168.6235 14.7145,201.1145 38.1275,224.7925 L68.5335,194.3865 Z"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[5] = element;
              }}
            />
            <path
              d="M42.9998,131.24 C43.1988,107.228 52.8998,85.488 68.5318,69.592 L38.1248,39.185 C14.7128,62.864 0.1998,95.353 -0.000199999999,131.24 L42.9998,131.24 Z"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[6] = element;
              }}
            />
            <path
              d="M69.5921,68.531 C85.4881,52.9 107.2281,43.199 131.2401,43 L131.2401,0 C95.3531,0.2 62.8631,14.714 39.1861,38.125 L69.5921,68.531 Z"
              fill="#47C085"
              ref={element => {
                outerRimRef.current[7] = element;
              }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

ChooseHosts.propTypes = {
  play: PropTypes.bool,
};

export default ChooseHosts;
